import Cookie from 'js-cookie'

// Types
import { APIActionData, SubscriptionState } from 'types'

export const initialState: SubscriptionState = {}

type StartTrialDone = {
  type: 'START_TRIAL_DONE'
}

type FetchTierOffersAction = {
  type: 'FETCH_TIER_OFFERS_DONE'
  data: {
    response: APIActionData
    code: string
  }
}

type SubscriptionReducerActionTypes = StartTrialDone | FetchTierOffersAction
const reducer = (state: SubscriptionState = initialState, action: SubscriptionReducerActionTypes): SubscriptionState => {
  switch (action.type) {
    case 'START_TRIAL_DONE': {
      Cookie.remove('refcode')
      return state
    }
    case 'FETCH_TIER_OFFERS_DONE': {
      const {
        data: {
          response: {
            entities: { tierOffers },
          },
          code,
        },
      } = action
      if (tierOffers) {
        return {
          ...state,
          [code]: tierOffers,
        }
      }
      return state
    }
    default:
      return state
  }
}

export default reducer
